import Message from './message';
export default class TrackMessage extends Message {
    fire(event, properties, options) {
        this.call({
            properties,
            eventName: event,
            apiMethod: 'track',
        }, options);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2stbWVzc2FnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jZHAvbWVzc2FnZXMvdHJhY2stbWVzc2FnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLE9BQU8sTUFBTSxXQUFXLENBQUM7QUFJaEMsTUFBTSxDQUFDLE9BQU8sT0FBTyxZQUFhLFNBQVEsT0FBMEI7SUFDbEUsSUFBSSxDQUNGLEtBQWEsRUFDYixVQUF1QixFQUN2QixPQUFvQztRQUVwQyxJQUFJLENBQUMsSUFBSSxDQUNQO1lBQ0UsVUFBVTtZQUNWLFNBQVMsRUFBRSxLQUFLO1lBQ2hCLFNBQVMsRUFBRSxPQUFPO1NBQ25CLEVBQ0QsT0FBTyxDQUNSLENBQUM7SUFDSixDQUFDO0NBQ0YifQ==